import React from 'react';
import { Sidebar, useUserinfo } from '@mss/mss-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from 'react-i18next';
import { Settings, HardDrive, Link, Activity, Server } from 'react-feather';

export default function EditSidebar() {
  const [t] = useTranslation(['authorization', 'configuration', 'common']);
  const [hasPermission] = useUserinfo();
  return (
    <Sidebar>
      {hasPermission('view_configuration_site') && (
        <Sidebar.Item
          title={t('Site configuration')}
          icon={<FontAwesomeIcon icon={faLayerGroup} size={'sm'} />}
          url="settings"
          data-ta="SiteConfigurationSidebar"
        />
      )}
      {hasPermission(['view_automation', 'change_automation']) && (
        <Sidebar.Item
          title={t('Automations')}
          icon={<Settings size={14} />}
          url="automations"
          data-ta="AutomationsSidebar"
        />
      )}
      {hasPermission(['view_customfield', 'change_customfield']) && (
        <Sidebar.Item
          title={t('Asset Configuration')}
          icon={<HardDrive size={14} />}
          url="asset-configuration"
          data-ta="AssetConfigurationSidebar"
        />
      )}
      {hasPermission(['view_servicenowconfig']) && (
        <Sidebar.Item
          title={t('configuration:Integrations')}
          icon={<Link size={14} to="#" />}
          url="integrations"
          data-ta="IntegrationsSidebar"
        />
      )}
      {hasPermission(['view_opcservergroupconfig']) && (
        <Sidebar.Item
          title={t('OPC Server Groups')}
          icon={<Server size={14} />}
          url="opc-servers"
          data-ta="OPCServersSidebar"
        />
      )}
      {hasPermission(['view_worker', 'change_worker']) && (
        <Sidebar.Item
          title={t('configuration:Workers')}
          icon={<Activity size={14} to="#" />}
          url="workers"
          data-ta="WorkersSidebar"
        />
      )}
    </Sidebar>
  );
}
